<ng-template #modelContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt">
      <h5 class="modal-title" id="modal-basic-title" style="text-align: center">
        Asset Confirmation
      </h5>
    </div>

    <div class="modal-body">
    <div class="row">
        <div class="col-md-6">
            <span>Pop UP Confirmation</span>
        </div>
    </div>
    </div>
  
    <div class="modal-footer" style="">
        <div class="row col-md-12">
          <div class="col-md-6"></div>
          <!-- <div class="col-md-3">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="excuteTransferDetails()"
            >
              Execute
            </button>
          </div> -->
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-secondary"
              (click)="closeModal()"
            >
              Close
            </button>
          </div>
        </div>
    </div>
  </ng-template>